import { Box } from '@mui/material';
import { PDFViewer, Page, Text, View, Document } from '@react-pdf/renderer';
import dayjs from 'dayjs';
import { isEmpty } from 'lodash-es';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  IWorkspacePaymentInfo,
  getStripeRechargeInvoiceById,
  getWorkspacePaymentInfo,
} from 'wisestep-api';

import { useUserContext } from '../../../context';
import styles from '../../invoicing/components/invoicePreview/Styles';

interface IInovice {
  id: number;
  amount: string;
  invoiceNumber: string;
  description: string;
  credited: number;
  createdOn: string;
}

const RechargeInvoicePDF = () => {
  const [invoice, setInvoice] = useState<IInovice | null>(null);
  const location = useParams();
  const loggedInUser = useUserContext();
  const [workspaceBillingInfo, setWorkspaceBillingInfo] = useState<IWorkspacePaymentInfo | null>(
    null
  );

  useEffect(() => {
    (async () => {
      const gstdetails = await getWorkspacePaymentInfo();
      setWorkspaceBillingInfo(gstdetails.data);
      if (location?.id && isEmpty(invoice)) {
        const res = await getStripeRechargeInvoiceById(location.id);
        setInvoice(res.data);
      }
    })();
  }, [invoice, location]);

  return (
    <Box>
      <PDFViewer height={window.innerHeight + 200} width="100%">
        <>
          {invoice && (
            <Document>
              <Page size="A4" wrap>
                <View style={styles.border}>
                  <View style={{ height: '100%', position: 'relative' }}>
                    <Text style={styles.title}>Invoice</Text>
                    <View style={styles.invoice_body}>
                      <View style={styles.half_section}>
                        <Text style={styles.subTitle}>Billed By: </Text>
                        <Text style={styles.subTitle_plain}>Wisestep Inc</Text>
                        <Text style={styles.text}>
                          5-9-22,Ground Floor,My Home Sarovar Plaza Secretariat Road,
                          Hyderabad-500063
                        </Text>
                      </View>
                      <View style={{ width: '37%', paddingLeft: 10 }}>
                        <Text style={styles.subTitle}>Wisestep Inc</Text>
                        <Text style={styles.subTitle_plain}>+1 732-226-8155</Text>
                        <Text style={styles.text}>paymentsupport@wisestep-inc.com</Text>
                      </View>
                    </View>

                    <View style={styles.invoice_body}>
                      <View style={styles.half_section}>
                        <Text style={styles.subTitle}>Billed to: </Text>
                        <View>
                          <Text style={styles.subTitle_plain}>
                            {`${loggedInUser?.userDTO?.firstName ?? ''} ${
                              loggedInUser?.userDTO?.lastName ?? ''
                            }`}
                          </Text>
                          {!isEmpty(workspaceBillingInfo?.address) && (
                            <Text style={styles.text}>{workspaceBillingInfo?.address ?? ''}</Text>
                          )}
                          <Text style={styles.text}>
                            {`${workspaceBillingInfo?.city ?? ''} ${
                              workspaceBillingInfo?.state ?? ''
                            } ${workspaceBillingInfo?.pincode}`}
                          </Text>
                          <Text style={styles.text}>{workspaceBillingInfo?.country ?? ''}</Text>
                        </View>
                      </View>
                      <View style={{ width: '37%', paddingLeft: 10 }}>
                        <View style={styles.midle_style}>
                          <Text style={styles.color_text}>Invoice Date:</Text>
                          <Text style={styles.text}>
                            {dayjs(invoice['createdOn']).format('DD MMM YYYY')}
                          </Text>
                        </View>
                      </View>
                    </View>
                    <View style={{ ...styles.half_section, marginLeft: 10 }}>
                      <Text style={{ ...styles.tax_style, marginTop: 4 }}>
                        Thanks for the business...!
                      </Text>
                    </View>

                    <View style={styles.invoice_table}>
                      <View style={styles.table_header}>
                        <Text style={{ width: '8%' }}>S. No.</Text>
                        <Text style={{ width: '45%', textAlign: 'center' }}>Description</Text>

                        <Text style={{ width: '20%', textAlign: 'center' }}>Quantity</Text>
                        <Text style={{ width: '20%', textAlign: 'center' }}>Amount</Text>
                      </View>
                      <View style={styles.table_row}>
                        <Text style={{ width: '8%' }}>{1}</Text>
                        <Text style={{ width: '45%', textAlign: 'center' }}>
                          Recharged SMS Credits
                        </Text>
                        <Text style={{ width: '20%', textAlign: 'center' }}>
                          {invoice.credited}
                        </Text>
                        <Text style={{ width: '20%', textAlign: 'center' }}>
                          {`$ ${invoice.amount}`}
                        </Text>
                      </View>
                    </View>

                    <Text
                      style={{
                        ...styles.text,
                        bottom: 0,
                        marginLeft: '14vh',
                        textAlign: 'center',
                        position: 'absolute',
                        display: 'flex',
                        justifyContent: 'center',
                        borderBottom: 1,
                      }}
                    >
                      This is a computer-generated document. No signature is required.
                    </Text>
                  </View>
                </View>
              </Page>
            </Document>
          )}
        </>
      </PDFViewer>
    </Box>
  );
};
export default RechargeInvoicePDF;
